export default __webpack_public_path__ + "assets/d180c6a06ebe960bd055ef857123d91f.jpeg";